import { ElementRef, EventEmitter, OnInit } from '@angular/core';
var CsPaginationPanelComponent = /** @class */ (function () {
    function CsPaginationPanelComponent(_hostRef) {
        var _this = this;
        this._hostRef = _hostRef;
        /** Sentinel value in pageList for window mode: render as "..." */
        this.PAGE_ELLIPSIS = 0;
        this.pageOffsetList = [5, 10, 20, 50, 100];
        this.maxPagesDisplayLength = 10;
        this.dropUpCalcAddOnSpace = 0; // Should be in `px` unit.
        this.onUpdatePagingParams = new EventEmitter();
        this.onInit = new EventEmitter();
        this.isDropUp = false;
        this.resetPagingList = function () { return _this.setPageSize(_this.pagingParams.pageSize, 'none', 1); };
    }
    Object.defineProperty(CsPaginationPanelComponent.prototype, "totalRecord", {
        set: function (value) {
            this._totalRecord = value;
            if (this.pagingParams && value >= 0) {
                var pageSize = this.pagingParams.pageSize || 5;
                this.setPageSize(pageSize, 'none');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsPaginationPanelComponent.prototype, "isWindowMode", {
        /** True when total pages exceed MAX_PAGES and we show a sliding window (no ellipsis logic) */
        get: function () {
            return this.totalPagesCount > CsPaginationPanelComponent.MAX_PAGES;
        },
        enumerable: true,
        configurable: true
    });
    CsPaginationPanelComponent.prototype.ngOnInit = function () {
        this.setInitialPagingParams();
        this.setPageList();
        this.setPaginationProps();
        this.updatePagingParams();
        this.init();
    };
    CsPaginationPanelComponent.prototype.init = function () {
        this.onInit.emit({ reset: this.resetPagingList });
    };
    CsPaginationPanelComponent.prototype.onMenuShown = function () {
        this.setDropUp();
    };
    CsPaginationPanelComponent.prototype.setDropUp = function () {
        var ddMenuHeight = (29 * this.pageOffsetList.length) + 2;
        var bottomBoundary = document.getElementsByTagName('body')[0].getBoundingClientRect().bottom - (this.dropUpCalcAddOnSpace || 0);
        var dropDownBottomPosition = this._hostRef.nativeElement.getBoundingClientRect().bottom;
        var availableBottomSpace = bottomBoundary - dropDownBottomPosition;
        this.isDropUp = availableBottomSpace <= ddMenuHeight;
    };
    CsPaginationPanelComponent.prototype.setInitialPagingParams = function () {
        this.pagingParams = {
            currentPage: (this.initialParams && this.initialParams.currentPage) || 1,
            pageSize: (this.initialParams && this.initialParams.pageSize) || 5,
            startRow: null,
            endRow: null
        };
    };
    CsPaginationPanelComponent.prototype.setPageList = function () {
        var pageSize = this.pagingParams.pageSize || 1;
        var total = this._totalRecord != null && this._totalRecord >= 0 ? this._totalRecord : 0;
        this.totalPagesCount = Math.ceil(total / pageSize) || 0;
        if (this.totalPagesCount <= CsPaginationPanelComponent.MAX_PAGES) {
            this.pageList = this.totalPagesCount ? Array(this.totalPagesCount).fill(0).map(function (_, i) { return i + 1; }) : [];
        }
        else {
            var current = this.pagingParams.currentPage || 1;
            var half = Math.floor(this.maxPagesDisplayLength / 2);
            var start_1 = Math.max(1, Math.min(current - half, this.totalPagesCount - this.maxPagesDisplayLength + 1));
            var end = Math.min(this.totalPagesCount, start_1 + this.maxPagesDisplayLength - 1);
            var size = end - start_1 + 1;
            this.pageList = Array(size).fill(0).map(function (_, i) { return start_1 + i; });
            if (this.totalPagesCount > end) {
                if (this.totalPagesCount > end + 1) {
                    this.pageList.push(this.PAGE_ELLIPSIS);
                }
                this.pageList.push(this.totalPagesCount);
            }
        }
    };
    CsPaginationPanelComponent.prototype.setPaginationProps = function () {
        var total = this._totalRecord != null && this._totalRecord >= 0 ? this._totalRecord : 0;
        var remainingLastPageRowCount = total % this.pagingParams.pageSize;
        this.pagingParams.startRow = (this.pagingParams.pageSize * (this.pagingParams.currentPage - 1)) + 1;
        this.pagingParams.endRow = this.totalPagesCount === this.pagingParams.currentPage && remainingLastPageRowCount ? (this.pagingParams.startRow - 1) + remainingLastPageRowCount : Math.min(this.pagingParams.pageSize * this.pagingParams.currentPage, total);
    };
    CsPaginationPanelComponent.prototype.setPageSize = function (offset, pagingEvent, currentPage) {
        this.pagingParams.currentEvent = pagingEvent || 'pageSize';
        this.pagingParams.pageSize = offset;
        this.pagingParams.currentPage = currentPage || Math.trunc(((this.pagingParams.startRow - 1) / this.pagingParams.pageSize)) + 1;
        this.setPageList();
        this.setPaginationProps();
        this.updatePagingParams();
    };
    CsPaginationPanelComponent.prototype.setCurrentPage = function (page) {
        this.pagingParams.currentEvent = 'pageNav';
        this.pagingParams.currentPage = page;
        this.setPageList();
        this.setPaginationProps();
        this.updatePagingParams();
    };
    CsPaginationPanelComponent.prototype.updatePagingParams = function () {
        this.onUpdatePagingParams.emit(this.pagingParams);
    };
    /** Max page numbers to create (avoids crash when total record count is huge, e.g. 250000) */
    CsPaginationPanelComponent.MAX_PAGES = 500;
    return CsPaginationPanelComponent;
}());
export { CsPaginationPanelComponent };
